import { getStyledTextUsedFonts } from '@wix/thunderbolt-becky-root'
import type { Component, WRichTextDefinition } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { isRichTextComponent, isStyledText } from '../../../utils/is'
import type { FeatureRefs } from '../../cssFeatures.types'

export const richTextFontFamilies = {
	predicate: (component: Component) => isRichTextComponent(component),
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) =>
			refs.dataQuery<WRichTextDefinition['data']>(component.dataQuery!),
		toViewItem: (__, compData) => {
			// @ts-ignore TODO - remove once Editor Elements Definitions will handle itwe have a proper type for compData
			const styledTextDataItem = compData?.data?.richText || compData
			if (isStyledText(styledTextDataItem)) {
				return getStyledTextUsedFonts(styledTextDataItem).fontFamilies.flatMap((x) => x.split(','))
			}
			return EMPTY_ARRAY
		},
	}),
}
